import { render } from "./MainNavigationSubmenu.vue?vue&type=template&id=fa796122&ts=true"
import script from "./MainNavigationSubmenu.vue?vue&type=script&lang=ts"
export * from "./MainNavigationSubmenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__